(function () {
  function showFeedback(root, message) {
    const feedback = root.querySelector('[data-wrecker-share-feedback]');
    if (!feedback) return;
    feedback.textContent = message;
    feedback.hidden = false;
    window.clearTimeout(feedback._hideTimer);
    feedback._hideTimer = window.setTimeout(function () {
      feedback.hidden = true;
      feedback.textContent = '';
    }, 3200);
  }

  async function shareProduct(root) {
    const url = root.dataset.productUrl;
    const title = root.dataset.shareTitle || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title: title, url: url });
        return;
      } catch (err) {
        if (err && err.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      showFeedback(root, root.dataset.copiedMsg || 'Link copied');
      return;
    } catch (_err) {
      /* fall through */
    }

    if (window.prompt) {
      window.prompt('Copy this link:', url);
    }
  }

  function init() {
    const root = document.querySelector('[data-wrecker-product-actions]');
    if (!root) return;

    const printBtn = root.querySelector('[data-wrecker-print]');
    const shareBtn = root.querySelector('[data-wrecker-share]');

    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        shareProduct(root);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
